/** 统一 outputs 行结构（兼容后端 url / 旧版 outputUrl） */
export function normalizeImg2ImgOutputRow(row, fallbackIndex = 0) {
  if (!row || typeof row !== 'object') return null;
  const url = String(row.outputUrl || row.url || row.imageUrl || '').trim();
  if (!url) return null;
  const index = Number.isFinite(Number(row.index)) ? Number(row.index) : fallbackIndex;
  const normalized = {
    ...row,
    url,
    outputUrl: url,
    imageUrl: row.imageUrl || url,
    status: row.status || 'success',
    index,
  };
  if (row.sourceIndex != null && Number.isFinite(Number(row.sourceIndex))) {
    normalized.sourceIndex = Number(row.sourceIndex);
  }
  return normalized;
}

function hydrateOutputsFromLocalUrlMap(result) {
  const localMap = result?.localCutoutUrls || result?.localEnhanceUrls || result?.localStampUrls;
  if (!localMap || typeof localMap !== 'object') return [];
  const entries = Object.entries(localMap)
    .map(([imageId, url]) => ({ imageId: String(imageId), url: String(url || '').trim() }))
    .filter((row) => row.url);
  if (entries.length === 0) return [];
  return entries.map((row, index) => normalizeImg2ImgOutputRow({
    url: row.url,
    index,
    sourceIndex: index,
    sourceImageId: row.imageId,
    status: 'success',
  }, index)).filter(Boolean);
}

/** 解析万能改图任务 result.outputs（兼容旧版单张 outputUrl、后端 url 字段） */
export function getImg2ImgOutputs(result) {
  if (!result || typeof result !== 'object') return [];
  if (Array.isArray(result.outputs) && result.outputs.length > 0) {
    return result.outputs
      .map((row, index) => normalizeImg2ImgOutputRow(row, index))
      .filter(Boolean);
  }
  const fromLocal = hydrateOutputsFromLocalUrlMap(result);
  if (fromLocal.length > 0) return fromLocal;
  if (Array.isArray(result.urls) && result.urls.length > 0) {
    return result.urls
      .map((url, index) => normalizeImg2ImgOutputRow({ url, index }, index))
      .filter(Boolean);
  }
  if (result.outputUrl) {
    return [
      normalizeImg2ImgOutputRow({
        index: 0,
        outputUrl: result.outputUrl,
        referencePreview: Array.isArray(result.referencePreviews) ? result.referencePreviews[0] : '',
        status: 'success',
      }, 0),
    ].filter(Boolean);
  }
  return [];
}

export function getImg2ImgOutputCount(result, taskTotal) {
  const outputs = getImg2ImgOutputs(result);
  const totalRaw = Number(taskTotal);
  if (Number.isFinite(totalRaw) && totalRaw > 0) return totalRaw;
  return Math.max(outputs.length, 1);
}
